<template>
  <div class="settlement-bill" @scroll="handleContractScroll">
    <v-loading :loading="loading"></v-loading>
    <div class="settlement-bill__header flex flex--align-center flex--justify-between">
      <v-item-title title="我的账单"></v-item-title>
    </div>
    <div class="settlement-bill__filter">
      <Row :gutter="16">
        <Col span="6">
          <span class="label">账单状态:</span>
          <Select :value="searchParams.status"
                  placeholder="账单状态"
                  @on-change="val => handleFilter(val, 'status')"
                  transfer>
            <Option value="all">{{'不限'}}</Option>
            <Option value="TOPAID">{{'待支付'}}</Option>
            <Option value="OVERDUE">{{'已逾期'}}</Option>
            <Option value="PAID">{{'已支付'}}</Option>
          </Select>
        </Col>
        <Col span="18">
          <Input prefix="ios-search"
                 v-model="searchParams.keyWord"
                 @on-enter="handleFilter()"
                 placeholder="账单编号"/>
        </Col>
      </Row>
    </div>
    <ul class="settlement-bill__body" v-if="dataList.length">
      <BillItem
        v-for="item in dataList"
        @on-loading="val => loading = val"
        :key="item.id"
        @on-pay-success="handlePaySuccess"
        :item="item"></BillItem>
    </ul>
    <div class="settlement-bill__body no-data" v-else>
      <v-no-data type="whole"
                 icon="iconphonelink_off-24px1"
                 title="暂无账单记录"
                 subtitle="如有购买需求，请联系商务"
      ></v-no-data>
    </div>
  </div>
</template>

<script>
import { getBillList } from '@/api/settlement/bill';
import { contractOrderTypeMap } from '@/config/enum.config';
import BillItem from './billItem.vue';

export default {
  name: 'settlement-bill',
  components: {
    BillItem,
  },
  data() {
    return {
      searchParams: {
        keyWord: '',
        status: 'all',
      },
      detailVisible: false,
      pageSize: 10,
      pageNum: 1,
      total: 0,
      loading: false,
      dataList: [],
      selection: null,
    };
  },
  created() {
    this.getBillList();
  },
  methods: {
    async getBillList(isSearch) {
      const { keyWord, status } = this.searchParams;
      this.loading = true;
      const res = await getBillList({
        billing_number: keyWord,
        billing_status: status === 'all' ? undefined : status,
        page_size: this.pageSize,
        page_num: this.pageNum,
      });
      if (res) {
        const data = res.data_list.map((item) => {
          if (item.billing_detail && item.billing_detail.length) {
            return {
              ...item,
              billing_detail: item.billing_detail.map((bill) => {
                const {
                  app_name, order_type, count, qps, excess_fees,
                } = bill;
                return {
                  ...bill,
                  order_content: order_type === 'EXTRA'
                    ? `${app_name} | ${contractOrderTypeMap[order_type]}订单 (${excess_fees}元/次 * ${count}次)`
                    : `${app_name} | ${contractOrderTypeMap[order_type]}订单 (${count}次/月 | QPS ${qps})`,
                };
              }),
            };
          }
          return item;
        });
        if (isSearch) {
          this.dataList = data;
        } else {
          this.dataList.push(...data);
        }
        this.total = res.total;
      } else if (isSearch) {
        this.dataList = [];
      }
      this.loading = false;
    },
    handleFilter(val, name) {
      if (val) {
        this.searchParams[name] = val;
      }
      this.pageNum = 1;
      this.getBillList(true);
    },
    handleContractScroll(e) {
      if (this.pageNum * this.pageSize < this.total && !this.loading) {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          this.pageNum += 1;
          this.getBillList();
        }
      }
    },
    handlePaySuccess(item) {
      const index = this.dataList.findIndex((d) => d.id === item.id);
      if (index > -1) {
        this.dataList.splice(index, 1, item);
      }
    },
  },
};
</script>

<style lang="less">
  .settlement-bill{
    height: 100%;
    padding: 16px;
    position: relative;
    overflow: auto;
    &__create-btn{
      font-weight: 500;
      padding: 0;
      width: 110px;
      height: 36px;
    }
    &__filter{
      padding: 30px 0 22px;
      .ivu-col{
        position: relative;
      }
      .label{
        color: rgba(0, 0, 0, 0.87);
        position: absolute;
        left: 16px;
        top: 6px;
        font-weight: 500;
        z-index: 1;
      }
      .ivu-input{
        border-radius: 8px;
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        border-color: rgba(0, 0, 0, 0.08);
      }
      .ivu-select{
        color: rgba(0, 0, 0, 0.87);
        font-weight: 500;
        position: relative;
        z-index: 2;
      }
      .ivu-select-selection{
        border-radius: 8px;
        border-color: rgba(0, 0, 0, 0.08);
        padding-left: 70px;
        box-shadow: none;
        background-color: transparent;
      }
    }
    &__body{
      &.no-data{
        padding-top: 150px;
      }
    }
  }
</style>
